import {bootstrapApplication} from '@angular/platform-browser';
import {registerLocaleData} from '@angular/common';
import localeIt from '@angular/common/locales/it';
import localeEn from '@angular/common/locales/en-GB';
// import localeJa from '@angular/common/locales/ja';
// import localeDe from '@angular/common/locales/de';

import {AppComponent} from './app/app.component';
import {appConfig} from './app/app.config';
import {environment} from './environments/environment';

registerLocaleData(localeIt, 'it');
registerLocaleData(localeEn, 'en');
// registerLocaleData(localeDe, 'de');
// registerLocaleData(localeJa, 'ja');

if (!environment.enableDebug) {
  // Strip non-essential console output in production builds. Keep warn/error
  // so real problems still surface in browser devtools and SDK error handlers.
  const noop = () => {};
  (console as any).log = noop;
  (console as any).debug = noop;
  (console as any).info = noop;
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
